export default __webpack_public_path__ + "static/media/kneeFlexionMidstance.4ee53604.png";